/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { connectionsListConnectionSourceTypes } from "../../funcs/connectionsListConnectionSourceTypes.js";
import { formatResult, ToolDefinition } from "../tools.js";

export const tool$connectionsListConnectionSourceTypes: ToolDefinition = {
  name: "connections-list-connection-source-types",
  description: `List Connection Source Types

List available connection source types like 'google_drive' and 'notion' along with their metadata`,
  tool: async (client, ctx) => {
    const [result, apiCall] = await connectionsListConnectionSourceTypes(
      client,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
